import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Center, ErrorModal, LinkButton, Stack } from 'src/components';
import { ROUTES } from 'src/constants/routes.const';
import { ZENDESK } from 'src/constants/links.const';
import { LearningSessionError, SessionType } from 'src/api/learningSessions/types';
import { getSessionTypeVars } from 'src/apps/LearningSession/sessionConfig';
import * as S from './styles';

const msgs = defineMessages({
  goToDashboard: { id: 'learning_session_error_button_dashboard' },
  goToPlans: { id: 'learning_session_error_button_plans' },
  reportBug: { id: 'learning_session_error_button_report_bug' },
});

export const BaseSessionErrorModal: FC<{
  sessionType: SessionType;
  error: LearningSessionError;
}> = ({ sessionType, error }) => {
  const intl = useIntl();
  const { width } = getSessionTypeVars(sessionType);

  return (
    <Center $centerAlignItems $maxWidth={width}>
      <ErrorModal
        isOpen
        errorTitle={intl.formatMessage(error.header)}
        errorDetail={intl.formatMessage(error.description)}
        testId="error-modal"
      >
        <Stack $direction="horizontal" $spacing="s3" $shouldWrap>
          <LinkButton href={ROUTES.dashboard} buttonSize="small" buttonType="primary">
            {intl.formatMessage(msgs.goToDashboard)}
          </LinkButton>
          {error.linkToPlans && (
            <LinkButton href={ROUTES.payment.plans} buttonSize="small" buttonType="primary">
              {intl.formatMessage(msgs.goToPlans)}
            </LinkButton>
          )}
          {error.extraInfoLink && (
            <S.ErrorReportBugLink href={error.extraInfoLink.url}>
              {intl.formatMessage(error.extraInfoLink.message)}
            </S.ErrorReportBugLink>
          )}
          <S.ErrorReportBugLink href={ZENDESK}>
            {intl.formatMessage(msgs.reportBug)}
          </S.ErrorReportBugLink>
        </Stack>
      </ErrorModal>
    </Center>
  );
};
